import { createTheme } from '@mui/material/styles';

// Paleta HolaVeci — verde tienda + amarillo maduro + terracota, sobre crema.
const palette = {
  mode: 'light',
  primary: {
    main: '#0F4C3A',      // verde profundo, tienda de barrio
    light: '#2E6E5A',
    dark: '#083025',
    contrastText: '#FBF7F0',
  },
  secondary: {
    main: '#F4B23C',      // amarillo maduro (mango, plátano)
    light: '#F8C868',
    dark: '#C9902A',
    contrastText: '#0F2A22',
  },
  error: {
    main: '#C0392B',
  },
  warning: {
    main: '#E85D3B',      // terracota, para fiado / cobros
  },
  success: {
    main: '#2E7D5B',
  },
  info: {
    main: '#3A6EA5',
  },
  background: {
    default: '#FBF7F0',   // crema
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1A1E1C',
    secondary: '#5A605D',
  },
  divider: 'rgba(15, 76, 58, 0.14)',
};

const theme = createTheme({
  palette,
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: `"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    h1: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.02em' },
    h2: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.02em' },
    h3: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.01em' },
    h4: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.01em' },
    h5: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600 },
    h6: { fontFamily: `"DM Sans", sans-serif`, fontWeight: 600, letterSpacing: '0.01em' },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
    overline: { fontWeight: 600, letterSpacing: '0.12em' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          paddingInline: 20,
          paddingBlock: 10,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          '&:hover': { backgroundColor: palette.primary.dark },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
      defaultProps: { elevation: 0 },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: `1px solid ${palette.divider}`,
          borderRadius: 14,
        },
      },
      defaultProps: { elevation: 0 },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FBF7F0',
          color: palette.text.primary,
          borderBottom: `1px solid ${palette.divider}`,
        },
      },
      defaultProps: { elevation: 0 },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', size: 'small' },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 600, backgroundColor: 'rgba(15, 76, 58, 0.04)' },
      },
    },
  },
});

export default theme;
